import React, { useState } from 'react';
import { Link, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

function RegisterPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setSuccess('');

    if (password !== confirmPassword) {
      setError(t('register.error_passwords_mismatch'));
      return;
    }

    if (password.length < 6) {
      setError(t('register.error_password_short'));
      return;
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/register`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, email, password }),
      });

      const data = await response.json();

      if (response.ok) {
        setSuccess(t('register.success'));
        setTimeout(() => {
          navigate({ to: '/login' });
        }, 2000);
      } else {
        setError(data.message || t('register.error_register_failed'));
      }
    } catch (err) {
      setError(t('register.error_generic'));
    }
  };

  return (
    <div className="container mt-5" style={{ maxWidth: '450px' }}>
      <h2 className="text-center mb-4">{t('register.title')}</h2>

      <div className="alert alert-info mb-4">
        <h6 className="mb-1">{t('register.plan_info_title')}</h6>
        <p className="mb-0 small">{t('register.plan_info_desc')}</p>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="form-group mb-3">
          <label htmlFor="username">{t('register.username')}</label>
          <input
            type="text"
            className="form-control"
            id="username"
            placeholder={t('register.username_placeholder')}
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
        </div>

        <div className="form-group mb-3">
          <label htmlFor="email">{t('register.email')}</label>
          <input
            type="email"
            className="form-control"
            id="email"
            placeholder={t('register.email_placeholder')}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>

        <div className="form-group mb-3">
          <label htmlFor="password">{t('register.password')}</label>
          <input
            type="password"
            className="form-control"
            id="password"
            placeholder={t('register.password_placeholder')}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            minLength={6}
          />
          <small className="form-text text-muted">{t('register.password_hint')}</small>
        </div>

        <div className="form-group mb-3">
          <label htmlFor="confirmPassword">{t('register.confirm_password')}</label>
          <input
            type="password"
            className="form-control"
            id="confirmPassword"
            placeholder={t('register.confirm_password_placeholder')}
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
          />
        </div>

        {error && <div className="alert alert-danger">{error}</div>}
        {success && <div className="alert alert-success">{success}</div>}

        <button type="submit" className="btn btn-success w-100 mb-3">
          {t('register.submit')}
        </button>
      </form>

      <div className="text-center">
        <p className="text-muted mb-0">
          {t('register.have_account')}{' '}
          <Link to="/login" className="text-primary">
            {t('register.login_link')}
          </Link>
        </p>
        <Link to="/" className="text-muted">
          {t('register.back_home')}
        </Link>
      </div>
    </div>
  );
}

export default RegisterPage;
